<template>
  <div class="features-details w-full">
    <vs-popup :active.sync="toggleForNewbiesPopup" :buttons-hidden="true">
      <div class="px-6 py-10 md:p-10">
        <img
          height="34"
          width="34"
          class="mr-5 float-left"
          src="@/assets/images/account-details/Question.svg"
        />
        <div class="md:flex md:flex-col">
          <p class="prompt-title mb-5 whitespace-no-wrap md:prompt-title">Confirmation</p>
          <p class="prompt-body mb-4 ml-0 md:prompt-body">
            Are you sure you want to
            <span v-if="!feature.newbies">disable</span><span v-else>enable</span> this feature for newbies ?
          </p>
        </div>

        <div class="flex flex-wrap mt-10 md:justify-end">
          <vs-button
            @click="handleConfirmationOk"
            class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last primary-btns"
          >Yes
          </vs-button>
          <vs-button
            class="w-full md:w-32 cancel-btns"
            type="border"
            @click="handleConfirmationCancel"
          >No
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="enableForAllPopup" :buttons-hidden="true">
      <div class="px-6 py-10 md:p-10">
        <img
          height="34"
          width="34"
          class="mr-5 float-left"
          src="@/assets/images/account-details/Question.svg"
        />
        <div class="md:flex md:flex-col">
          <p class="prompt-title mb-5 whitespace-no-wrap md:prompt-title">Confirmation</p>
          <p class="prompt-body mb-4 ml-0 md:prompt-body">
            Are you sure you want to Enable this Feature for all Accounts in the System !!
          </p>
        </div>

        <div class="flex flex-wrap mt-10 md:justify-end">
          <vs-button
            @click="enableForAllAction"
            class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last primary-btns"
          >Yes
          </vs-button>
          <vs-button
            class="w-full md:w-32 cancel-btns"
            type="border"
            @click="enableForAllPopup = false"
          >No
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="disableForAllPopup" :buttons-hidden="true">
      <div class="px-6 py-10 md:p-10">
        <img
          height="34"
          width="34"
          class="mr-5 float-left"
          src="@/assets/images/account-details/Question.svg"
        />
        <div class="md:flex md:flex-col">
          <p class="prompt-title mb-5 whitespace-no-wrap md:prompt-title">Confirmation</p>
          <p class="prompt-body mb-4 ml-0 md:prompt-body">
            Are you sure you want to Disable this Feature for all Accounts in the System !!
          </p>
        </div>

        <div class="flex flex-wrap mt-10 md:justify-end">
          <vs-button
            id="feature-details-confirmation-yes-button"
            @click="disableForAllAction"
            class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last primary-btns"
          >Yes
          </vs-button>
          <vs-button
            id="feature-details-confirmation-no-button"
            class="w-full md:w-32 cancel-btns"
            type="border"
            @click="disableForAllPopup = false"
          >No
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vx-card class="mb-5">
      <div class="lg:mx-4 md:m-0">
        <div class="mb-8 lg:mt-3">
          <h2 class="subtitles pt-2 md:subtitles">Feature Details</h2>
        </div>

        <div class="mb-8">
          <div class="labels pb-4 md:labels">Name</div>
          <p class="small-txt">{{ feature.name }}</p>
        </div>

        <div class="mb-3">
          <div class="labels pb-4 md:labels">Accessibility</div>
          <p class="small-txt">You can only choose ONE option only.</p>
        </div>

        <div class="mb-6 md:space-x-4 space-y-5">
          <vs-button
            id="feature-details-enable-button"
            class="w-full lg:w-1/4 btn enable-btn shadow-none"
            @click="enableForAll"
            color="primary"
          >Enable For All Accounts
          </vs-button>

          <vs-button
            id="feature-details-disable-button"
            class="w-full lg:w-1/4 btn disable-btn shadow-none"
            @click="disableForAll"
            color="primary"
            type="border"
          >Disable For All Accounts
          </vs-button>
        </div>

        <div class="mb-8">
          <vs-checkbox id="feature-details-enable-newbies-button" class="newbies" @change="confirmDisableForNewbies" v-model="feature.newbies">
            <span class="pl-4">Enable for newbies</span>
          </vs-checkbox>
        </div>
      </div>
    </vx-card>

    <vx-card class="lg:p-3 md:p-0">
      <vs-row class="flex justify-between">
        <div class="pt-2">
          <h2 class="text-xl flex items-center subtitles">Accounts</h2>
        </div>

        <div class="relative mb-4 lg:w-1/5 w-full">
          <input
            id="feature-details-user-email-input"
            type="text"
            placeholder="User email"
            v-model="searchQuery"
            @input="searchInputChanged"
            class="accounts-input"
          >
          <vs-icon class="accounts-search-icon" icon-pack="speakol" icon="speakol-search"></vs-icon>
          <!-- <speakol-input
            placeholder="User email"
            v-model="searchQuery"
            @input="searchInputChanged"
            class="w-full"
            icon="speakol-search">
          </speakol-input> -->
        </div>
      </vs-row>

      <vs-row>
        <a-g-speakol-table ref="featureDetails" :filters="agFilters" :columns="agColumns" :options="agOptions"/>
      </vs-row>

    </vx-card>
  </div>
</template>

<script>

import AGSpeakolTable from '@/components/AGSpeakolTable'
import AccountNameColumn from './AgGridTableComponents/account-name-col'
import StatusColumn from './AgGridTableComponents/status-col'
import { Server, DataSource } from '@/datasources/DataSource'

export default {
  components: {
    AGSpeakolTable,
    AccountNameColumn,
    StatusColumn
  },
  mounted () {
    this.getFeatureDetails()
  },
  data () {
    return {
      accounts: {},
      feature: {},
      toggleForNewbiesPopup: false,
      toggleForNewbies: false,
      enableForAllPopup: false,
      disableForAllPopup: false,
      perPage: 10,
      searchQuery: '',
      searchTimeout: null,
      agOptions: {
        dataSource: DataSource(
          Server(`/features/${this.$route.params.id}/get-accounts`)
        )
      },
      agColumns: [
        {
          cellRendererFramework: 'AccountNameColumn',
          headerName: 'Account Name',
          minWidth: 400
        },
        {
          cellRendererFramework: 'StatusColumn',
          headerName: 'Status',
          maxWidth: 100,
          minWidth: 100,
          resizable: false
        }
      ],
      agFilters: {
        searchQuery: null
      }
    }
  },
  methods: {
    async getFeatureDetails () {

      const {data} = await window.axios.get(`/features/${this.$route.params.id}`)
      this.feature = data.payload

    },

    async applyFilters () {
      this.agFilters['searchQuery'] = this.searchQuery
      this.$refs['featureDetails'].applyFilters()

    },

    async enableForAll () {
      this.enableForAllPopup = !this.enableForAllPopup
    },

    async enableForAllAction () {
      this.enableForAllPopup = false


      await window.axios.post(`/features/${this.$route.params.id}/enable-for-all`)
      await this.applyFilters()


    },

    async disableForAll () {
      this.disableForAllPopup = !this.disableForAllPopup
    },

    async disableForAllAction () {
      this.disableForAllPopup = false

      await window.axios.post(`/features/${this.$route.params.id}/disable-for-all`)
      await this.applyFilters()


    },

    confirmDisableForNewbies () {
      this.toggleForNewbiesPopup = !this.toggleForNewbiesPopup
    },

    async handleConfirmationOk () {
      this.toggleForNewbiesPopup = !this.toggleForNewbiesPopup

      const response = await window.axios.post(`/features/${this.$route.params.id}/toggle-for-newbies`)

      if (response.data.status !== 200) {
        // display error then
        this.feature.newbies = !this.feature.newbies
      }


    },

    handleConfirmationCancel () {
      this.feature.newbies = !this.feature.newbies
      this.toggleForNewbiesPopup = !this.toggleForNewbiesPopup
    },


    async searchInputChanged () {
      clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => {
        this.applyFilters()
      }, 600)
    }
  }
}
</script>

<style lang="scss" scoped>

$speakolColor: "#0092D7";

.btn {
  padding: 8px 28px 8px 28px;
  border-radius: 25px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-align: center;

  .enable-btn {
    background: $speakolColor;
  }

  .disable-btn {
    color: $speakolColor;
    background: #fff;
  }
}

.small-txt {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.56);
}

.newbies {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.prompt-title {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 27px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.labels {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.subtitles {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
}

@media (min-width: 768px) {
  .md\:labels {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .md\:subtitles {
    font-size: 24px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #000;
    margin-top: 14px;
  }

  .md\:inputs {
    height: 40px;
  }

  .md\:prompt-title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .md\:prompt-body {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.56);
  }
}

.accounts-input {
  height: 40px;
  width: 100%;
  text-indent: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.accounts-search-icon {
  position: absolute;
  left: 6px;
  top: 8px;
  color: #d9d9d9;
}

.features-details {
  ::placeholder {
    color: #d9d9d9;
  }
}
</style>
